module.exports = __webpack_public_path__ + "static/media/5.7177e3a3.JPG";